function animateCartFloatingBubbleIncrease(cartFloatingBubble, increaseAmount) {
    if (!cartFloatingBubble || increaseAmount <= 0) return;

    const plusTag = document.createElement('span');
    plusTag.className = 'cart-floating-bubble__plus-rise';
    plusTag.textContent = `+${increaseAmount}`;
    cartFloatingBubble.appendChild(plusTag);

    plusTag.addEventListener('animationend', () => {
      plusTag.remove();
    }, { once: true });
  }

  function animateCartFloatingBubbleReceive(cartFloatingBubble) {
    if (!cartFloatingBubble) return;

    cartFloatingBubble.classList.remove('cart-floating-bubble--receiving');
    void cartFloatingBubble.offsetWidth;
    cartFloatingBubble.classList.add('cart-floating-bubble--receiving');

    cartFloatingBubble.addEventListener('animationend', function handleReceiveAnimationEnd(event) {
      if (event.animationName === 'cart-bubble-receive') {
        cartFloatingBubble.classList.remove('cart-floating-bubble--receiving');
      }
    }, { once: true });
  }

  function updateCartFloatingBubbleCount(cartFloatingBubble, itemCount) {
    const countElement = cartFloatingBubble.querySelector('.cart-floating-bubble__count');
    if (!countElement) return;

    if (itemCount > 0) {
      const displayCount = itemCount < 100 ? itemCount : '99+';
      countElement.innerHTML = `<span aria-hidden="true">${displayCount}</span><span class="visually-hidden">${itemCount} items</span>`;
    } else {
      countElement.innerHTML = '';
    }
  }

  function initCartFloatingBubbleCta() {
    const cartFloatingBubble = document.getElementById('cartFloatingBubble');
    const ctaContainer = document.getElementById('cartFloatingBubbleCta');
    if (!cartFloatingBubble) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const newItemCount = Number(cart.item_count || 0);
            const previousItemCount = Number(cartFloatingBubble.dataset.itemCount || 0);

            cartFloatingBubble.dataset.itemCount = newItemCount;
            updateCartFloatingBubbleCount(cartFloatingBubble, newItemCount);

            if (newItemCount > previousItemCount) {
              animateCartFloatingBubbleIncrease(cartFloatingBubble, newItemCount - previousItemCount);
              animateCartFloatingBubbleReceive(cartFloatingBubble);
            }
          })
          .catch(() => {});
      });
    }

    if (!ctaContainer) return;

    const texts = Array.from(ctaContainer.querySelectorAll('.cart-floating-bubble__cta-text'));
    if (!texts.length) return;

    const hiddenSeconds = Number(ctaContainer.dataset.interval) || 60;
    let activeText = null;
    let cycleTimer = null;

    function hasItemsInCart() {
      return Number(cartFloatingBubble.dataset.itemCount || 0) > 0;
    }

    function isEligible(text) {
      return text.dataset.requiresItems !== 'true' || hasItemsInCart();
    }

    function setActive(text) {
      texts.forEach((t) => t.classList.toggle('is-active', t === text));
      activeText = text;
      ctaContainer.style.setProperty('--cta-connector-color', text.style.backgroundColor);
    }

    function showNextText() {
      const eligibleTexts = texts.filter(isEligible);
      if (!eligibleTexts.length) {
        activeText = null;
        ctaContainer.classList.remove('is-visible');
        cycleTimer = setTimeout(showNextText, 1000);
        return;
      }
      const currentIndex = eligibleTexts.indexOf(activeText);
      const nextText = eligibleTexts[(currentIndex + 1) % eligibleTexts.length];
      setActive(nextText);
      ctaContainer.classList.add('is-visible');
      const durationSeconds = Number(nextText.dataset.duration) || 5;
      cycleTimer = setTimeout(hideText, durationSeconds * 1000);
    }

    function hideText() {
      ctaContainer.classList.remove('is-visible');
      cycleTimer = setTimeout(showNextText, hiddenSeconds * 1000);
    }

    showNextText();

    new MutationObserver(() => {
      if (activeText && !isEligible(activeText)) {
        clearTimeout(cycleTimer);
        activeText = null;
        ctaContainer.classList.remove('is-visible');
        cycleTimer = setTimeout(showNextText, 1000);
      }
    }).observe(cartFloatingBubble, {
      attributes: true,
      attributeFilter: ['data-item-count'],
    });
  }

  document.addEventListener('DOMContentLoaded', initCartFloatingBubbleCta);